module.exports = __webpack_public_path__ + "static/media/pinkbig.f0c96ecb.svg";